import { render, staticRenderFns } from "./AsyncFallbakPopup.vue?vue&type=template&id=4c24fee6&scoped=true"
import script from "./AsyncFallbakPopup.vue?vue&type=script&lang=js"
export * from "./AsyncFallbakPopup.vue?vue&type=script&lang=js"
import style0 from "./AsyncFallbakPopup.vue?vue&type=style&index=0&id=4c24fee6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c24fee6",
  null
  
)

export default component.exports